<div class="farm-notes" [nbSpinner]="isLoading">
  <!-- Composer -->
  <div *ngIf="canEdit" class="composer">
    <div class="type-row">
      <button type="button" class="type-chip" *ngFor="let t of types" [class.active]="newType === t.name"
        [style.background]="newType === t.name ? t.color : null" [style.borderColor]="t.color"
        (click)="newType = t.name">
        <fa-icon [icon]="icon(t.icon)" size="sm"></fa-icon> {{t.name}}
      </button>
      <button type="button" class="manage-link" (click)="manageTypes()">Manage types</button>
    </div>
    <textarea class="composer-text" rows="3" [(ngModel)]="newNote" name="newFarmNote"
      placeholder="Write a note… (Ctrl/Cmd+Enter to add)" (keydown)="onComposerKey($event)"></textarea>
    <div class="composer-actions">
      <button mat-raised-button color="primary" [disabled]="!newNote.trim() || isAdding" (click)="addNote()">
        Add Note
      </button>
    </div>
  </div>

  <div *ngIf="!isLoading && notes.length === 0" class="empty-state">No notes yet.</div>

  <!-- Timeline -->
  <div class="timeline-item" *ngFor="let n of notes">
    <div class="avatar" [style.background]="colorFor(n.type)">
      <fa-icon [icon]="icon(iconNameFor(n.type))" size="sm"></fa-icon>
    </div>

    <div class="body">
      <div class="meta">
        <span class="type-pill" [style.background]="colorFor(n.type)">{{n.type || 'Note'}}</span>
        <strong>{{n.createdBy || 'Unknown'}}</strong>
        <span class="when">{{n.timeCreated | date:'medium'}}</span>
        <span *ngIf="wasEdited(n)" class="edited"
          [matTooltip]="'Edited by ' + (n.updatedBy || 'Unknown') + ' on ' + (n.timeModified | date:'medium')">(edited)</span>

        <span class="spacer"></span>
        <ng-container *ngIf="canEdit && !n._editing">
          <button mat-icon-button matTooltip="Edit" (click)="startEdit(n)"><fa-icon [icon]="faPen" size="sm"></fa-icon></button>
          <button mat-icon-button matTooltip="Delete" (click)="confirmDelete(n)"><fa-icon [icon]="faTrash" size="sm"></fa-icon></button>
        </ng-container>
      </div>

      <div *ngIf="!n._editing" class="note-text">{{n.note}}</div>

      <div *ngIf="n._editing" class="edit-form">
        <select class="type-select" [(ngModel)]="n._draftType" name="draftType{{n.id}}">
          <option *ngFor="let name of editTypesFor(n)" [value]="name">{{name}}</option>
        </select>
        <textarea class="composer-text" rows="3" [(ngModel)]="n._draftNote" name="draftNote{{n.id}}"></textarea>
        <div class="composer-actions">
          <button mat-button (click)="cancelEdit(n)">Cancel</button>
          <button mat-raised-button color="primary" [disabled]="!(n._draftNote || '').trim()" (click)="saveEdit(n)">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
